import { useTranslation } from 'react-i18next';
import { SubPartnerAccountStatus, withStyles } from 'vopay';
import { Button } from 'UI';
import usePartnerFilterFormConfig from './usePartnerFilterFormConfig';
import styles from './PartnerManagementPage.module.scss';

const cn = withStyles(styles);

export type PartnerSearchValues = {
  /** Empty for no status filter. */
  status: SubPartnerAccountStatus | '';
  searchText: string;
};

type PartnerManagementSearchFormProps = PartnerSearchValues & {
  /** The statuses the Status filter offers. */
  statuses: SubPartnerAccountStatus[];
  /** While true the Status filter is disabled: its options are still being fetched. */
  isLoadingStatuses: boolean;
  onSearch: (values: PartnerSearchValues) => void;
};

export default function PartnerManagementSearchForm({
  status,
  searchText,
  statuses,
  isLoadingStatuses,
  onSearch,
}: PartnerManagementSearchFormProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Partners.PartnerManagement.SearchForm' });

  const { ctx, renderFormElements } = usePartnerFilterFormConfig({
    initialValues: { Status: status, SearchText: searchText },
    statuses,
    isLoadingStatuses,
    // The Select's clear control stores null despite the string type; both that and '' mean no filter.
    onSubmit: (values) => onSearch({ status: values.Status || '', searchText: values.SearchText }),
  });

  return (
    <form onSubmit={ctx.handleSubmit} className={cn('searchArea')}>
      {renderFormElements()}

      <Button id="partner-management-search" type="submit" colorScheme="primary" size="small">
        {t('searchButton', { defaultValue: 'Search' })}
      </Button>
    </form>
  );
}
